// src/pages/ProfilePage.jsx
import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { ref, get, update } from "firebase/database";
import "../css/ProfilePage.css";

const ProfilePage = () => {
  const [userData, setUserData] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [form, setForm] = useState({});
  const user = auth.currentUser;

  useEffect(() => {
    if (user) {
      const userRef = ref(db, `users/${user.uid}`);
      get(userRef).then((snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          setUserData(data);
          setForm(data); // 初始化表单内容
        }
      });
    }
  }, [user]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    if (user) {
      const userRef = ref(db, `users/${user.uid}`);
      await update(userRef, form);
      setUserData(form);
      setEditMode(false);
    }
  };

  if (!user) {
    return (
      <p className="profile-container">Please login to view your profile.</p>
    );
  }

  return (
    <div className="profile-container">
      <h2>Your Profile</h2>

      {!userData ? (
        <p>Loading...</p>
      ) : (
        <div>
          {!editMode ? (
            <ul className="profile-list">
              <li>
                <strong>Full Name:</strong> {userData.fullName}
              </li>
              <li>
                <strong>Email:</strong> {user.email}
              </li>
              <li>
                <strong>School:</strong> {userData.school}
              </li>
              <li>
                <strong>Gender:</strong> {userData.gender}
              </li>
              <li>
                <strong>User Type:</strong> {userData.userType}
              </li>
              <button onClick={() => setEditMode(true)} className="edit-btn">
                Edit
              </button>
            </ul>
          ) : (
            <div className="edit-form">
              <label>Full Name:</label>
              <input
                type="text"
                name="fullName"
                value={form.fullName}
                onChange={handleChange}
              />

              <label>School:</label>
              <input
                type="text"
                name="school"
                value={form.school}
                onChange={handleChange}
              />

              <label>Gender:</label>
              <select name="gender" value={form.gender} onChange={handleChange}>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>

              <label>User Type:</label>
              <select
                name="userType"
                value={form.userType}
                onChange={handleChange}
              >
                <option value="Student">Student</option>
                <option value="Mentor">Mentor</option>
              </select>

              <button onClick={handleSave} className="save-btn">
                Save
              </button>
              <button onClick={() => setEditMode(false)} className="cancel-btn">
                Cancel
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ProfilePage;
